module.exports = __webpack_public_path__ + "static/media/Slimamif.00767a44.ttf";